export type InjectScriptOptions = {
  url?: string;
  text?: string;
  id?: string;
  type?: string;
  onLoad?: () => void;
  onError?: () => void;
  async?: boolean;
  defer?: boolean;
};

export const injectScript = ({
  url,
  text,
  id,
  type,
  onLoad,
  onError,
  async,
  defer,
}: InjectScriptOptions) => {
  const scriptId =
    id || `script-${Math.random().toString(36).substring(2, 15)}`;
  const script = document.createElement('script');

  if (url) {
    script.src = url;
  } else if (text) {
    script.textContent = text;
  } else {
    throw new Error('Either url or text must be provided');
  }

  script.type = type || 'text/javascript';
  script.id = scriptId;
  script.setAttribute('data-injected-script', scriptId);

  if (async) {
    script.async = true;
  }
  if (defer) {
    script.defer = true;
  }
  if (onLoad) {
    script.onload = onLoad;
  }
  if (onError) {
    script.onerror = onError;
  }
  document.head.appendChild(script);

  if (text) {
    onLoad?.();
  }

  return {
    id: scriptId,
    remove: () => {
      document.head.removeChild(script);
    },
  };
};
